import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-rose-50 via-white to-blush-50">
      {/* Navigation minimale */}
      <nav className="absolute top-0 left-0 right-0 z-20 py-6 px-6 lg:px-12">
        <div className="container mx-auto flex justify-between items-center">
          <div className="text-2xl font-light text-gray-900">
            Peau<span className="font-semibold text-rose-500">Perlée</span>
          </div>
        </div>
      </nav>

      <div className="container mx-auto px-6 lg:px-12 relative z-10 pt-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-5xl lg:text-7xl font-light text-gray-900 mb-6 leading-tight">
              Votre beauté commence <span className="font-semibold text-rose-500">ici</span>
            </h1>
            <p className="text-xl lg:text-2xl text-gray-600 mb-12 max-w-2xl mx-auto">
              Révélez votre peau. Choisissez votre parcours beauté.
            </p>
          </div>

          {/* Deux choix principaux */}
          <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {/* Boutique */}
            <Link to="/boutique" className="group cursor-pointer">
              <div className="relative h-[500px] rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500">
                <img 
                  src="https://public.readdy.ai/ai/img_res/b4286672d6036e81d147096cd236e666.jpg"
                  alt="Boutique Coréenne Beauté Premium"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                
                <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                  <h2 className="text-3xl font-semibold mb-3">Boutique Coréenne Beauté Premium</h2>
                  <p className="text-lg mb-6 text-white/90">Les soins qui transforment votre peau</p>
                  <div className="inline-flex items-center px-6 py-3 bg-white text-rose-600 rounded-full font-medium group-hover:bg-rose-500 group-hover:text-white transition-all duration-300 whitespace-nowrap">
                    Découvrir les produits
                    <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </div>
              </div>
            </Link>

            {/* Soins Esthétiques */}
            <Link to="/soins-esthetiques" className="group cursor-pointer">
              <div className="relative h-[500px] rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20aesthetic%20facial%20treatment%20in%20modern%20spa%20clinic%20with%20advanced%20technology%20device%20elegant%20treatment%20room%20with%20soft%20pink%20lighting%20serene%20atmosphere%20beauty%20therapy%20professional%20skincare%20clean%20minimalist%20medical%20aesthetic%20environment&width=600&height=800&seq=soins-hero-001&orientation=portrait"
                  alt="Soins au Plasma Froid"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                
                <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                  <h2 className="text-3xl font-semibold mb-3">Soins au Plasma Froid</h2>
                  <p className="text-lg mb-2 text-white/90">Mons & Domicile en Belgique</p>
                  <p className="text-sm mb-6 text-white/80">Technologie avancée, résultats visibles</p>
                  <div className="inline-flex items-center px-6 py-3 bg-white text-rose-600 rounded-full font-medium group-hover:bg-rose-500 group-hover:text-white transition-all duration-300 whitespace-nowrap">
                    Réserver mon soin
                    <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          {/* Trust indicators */}
          <div className="mt-16 flex flex-wrap justify-center items-center gap-8 text-gray-600 text-sm">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-rose-500 text-xl"></i>
              <span>Produits certifiés</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-truck-line text-rose-500 text-xl"></i>
              <span>Livraison rapide</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-star-fill text-rose-500 text-xl"></i>
              <span>4.9/5 - 500+ avis</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-map-pin-line text-rose-500 text-xl"></i>
              <span>Mons & Domicile</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
